import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { ThemeProvider as ThemeProvider$2 } from '@emotion/react';
import { presetTheme } from '../../theme/index.js';
import mergeObjects from '../../utility/mergeObjects.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ThemeProvider = (props) => {
  const { children, theme = {}, mode = "light", locale = "fa-IR" } = props;
  const preparedTheme = useMemo(() => {
    const mergedTheme = mergeObjects(presetTheme, __spreadProps(__spreadValues({}, theme), { locale }));
    return __spreadProps(__spreadValues({}, mergedTheme), {
      colors: mergedTheme.colors[mode],
      elevation: mergedTheme.elevation[mode],
      typography: mergedTheme.typography[locale],
      mode
    });
  }, [theme, mode, locale]);
  const directionWrapper = preparedTheme.typography.direction;
  return /* @__PURE__ */ jsx(ThemeProvider$2, { theme: preparedTheme, children: /* @__PURE__ */ jsx("main", { dir: directionWrapper, children }) });
};
var ThemeProvider$1 = ThemeProvider;

export { ThemeProvider$1 as default };
